import type { Bordereau, Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BaseBordereauState from './BaseBordereauState';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import BordereauDenumeroterAction from '../actions/BordereauDenumeroterAction';

class BordereauArchiveState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.ARCHIVE;
    this.state = BordereauStateType.ARCHIVE;
    this.color = '#666A82';
    this.libelle = 'Archivé';
  }

  getBordereauActions(_bordereau : Bordereau, userRole : UserRole): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
      new BordereauDenumeroterAction({ isRejet: true }),
      ...(userRole === UserRole.ADMIN) ? [
        new BordereauModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }

  getMouvementActions(userRole : UserRole): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
      new MouvementModifierAction({ isReadonly: true }),
      ...(userRole === UserRole.ADMIN) ? [
        new MouvementModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }
}

export default BordereauArchiveState;
